module.exports = __webpack_public_path__ + "static/media/New-order Icon.9dfb2540.png";